import { KeyOutlined, MailOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import { Descriptions, Space, Tag, Typography } from 'antd';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../layouts/PageLayout';
import { configService } from '../services/configService';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();
  const [licenseEnabled, setLicenseEnabled] = useState<boolean>(true); // Default to true to avoid flicker

  // Fetch license enabled setting from API
  useEffect(() => {
    configService.getPublicConfig().then(config => {
      setLicenseEnabled(config.licenseEnabled);
    });
  }, []);

  return (
    <PageLayout title="Profile Information">
      <Descriptions column={1} bordered>
        <Descriptions.Item
          label={
            <Space>
              <WalletOutlined />
              <span>Phantom Wallet Address</span>
            </Space>
          }
        >
          {user?.walletAddress ? (
            <Typography.Text copyable={{ text: user.walletAddress }}>
              {user.walletAddress}
            </Typography.Text>
          ) : (
            <Typography.Text type="secondary">Not connected</Typography.Text>
          )}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <Space>
              <MailOutlined />
              <span>Email</span>
            </Space>
          }
        >
          {user?.email ? (
            <Typography.Text>{user.email}</Typography.Text>
          ) : (
            <Typography.Text type="secondary">Not set</Typography.Text>
          )}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <Space>
              <UserOutlined />
              <span>First Name</span>
            </Space>
          }
        >
          <Typography.Text type="secondary">Not set</Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <Space>
              <UserOutlined />
              <span>Last Name</span>
            </Space>
          }
        >
          <Typography.Text type="secondary">Not set</Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <Space>
              <UserOutlined />
              <span>Username</span>
            </Space>
          }
        >
          {user?.username ? (
            <Typography.Text>{user.username}</Typography.Text>
          ) : (
            <Typography.Text type="secondary">Not set</Typography.Text>
          )}
        </Descriptions.Item>

        {licenseEnabled && (
          <Descriptions.Item
            label={
              <Space>
                <KeyOutlined />
                <span>License</span>
              </Space>
            }
          >
            {user?.licenseExpiresAt ? (
              <Space direction="vertical" size="small">
                <Space>
                  <Tag color={user.licenseExpiresAt > new Date() ? 'green' : 'red'}>
                    {user.licenseExpiresAt > new Date() ? 'Active' : 'Expired'}
                  </Tag>
                  <Typography.Text>
                    Expires: {format(user.licenseExpiresAt, 'PPpp')}
                  </Typography.Text>
                </Space>
                {user.licenseExpiresAt > new Date() && (
                  <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                    {Math.ceil((user.licenseExpiresAt.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))} days remaining
                  </Typography.Text>
                )}
              </Space>
            ) : (
              <Tag color="default">No license</Tag>
            )}
          </Descriptions.Item>
        )}
      </Descriptions>
    </PageLayout>
  );
};

export default ProfilePage;
